import React from 'react';
import { Card, CardContent, Grid, Button } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';
import ButtonBack from '../Breadcrumb/ButtonBack';

const Ayuda = () => {
  return (
    <Grid container spacing={1}>
      <ButtonBack />
      <Grid item xs={12}>
        <Grid container justifyContent='flex-end' sx={{ mb: 1 }}>
          <Button
            variant='contained'
            color='success'
            startIcon={<WhatsApp />}
            href='https://wa.me/5493435325271'
            target='_blank'
          >
            Contactar Mesa de Ayuda
          </Button>
        </Grid>
        <Card sx={{ width: '100%' }}>
          <CardContent>
            <iframe
              title='Preview'
              src='https://www.oser.gob.ar/ManualdeUsuario_MICONSULTORIO.pdf'
              width={'100%'}
              height={500}
              loading='lazy'
              allowFullScreen={true}
              style={{
                border: 'none',
                height: 'calc(100vh - 200px)',
              }}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Ayuda;
